import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

/** Bound stalled API requests; never replay a write after an uncertain result. */
@Injectable()
export class LoadingRequestInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    if (!request.url.startsWith(environment.apiHost + '/')) return next.handle(request);
    const longOperation = request.reportProgress || /download|export|report|import|upload/i.test(request.url);
    const limit = longOperation ? 180000 : request.method === 'GET' ? 30000 : 120000;
    return next.handle(request).pipe(timeout({ each: limit }));
  }
}
